import template from './master_cash_schedule.html';
import controller from './master_cash_schedule.controller';
import './master_cash_schedule.scss';

let MasterCashSchedualeComponent = {
    restrict: 'E',
    template,
    controller
};

export default MasterCashSchedualeComponent;



// WEBPACK FOOTER //
// ./client/app/components/master_cash_schedule/master_cash_schedule.component.js